import { extendObservable } from 'mobx';

class FAQ {
  constructor(question) {
    extendObservable(this, {
      question: question.question,
      answer: question.answer,
      link: question.link || null,
      showAnswer: false,
    });
  }

  toggleShowAnswer = () => {
    if (this.showAnswer) {
      this.showAnswer = false;
    } else {
      this.showAnswer = true;
    }
  };
}

export default FAQ;
